'use strict';

const BasePresenter = require('./base');

class SectionPresenter extends BasePresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    return {
      discountEnabled: this.model.getDiscountEnabled(),
      price: this.model.getFormattedPrice(),
      isSelected: (this.options.selection && this.options.selection.getTitle() === this.model.getTitle()) || false,
      title: this.model.getTitle(),
      value: this.model.getFormattedValue(),
    };
  }
}

module.exports = SectionPresenter;
